module.exports = __webpack_public_path__ + "img/P25-zh.9c704f11.png";